import {UserInsights} from "types/User";
import {dateTime} from "services/date";

/**
 * Transform the given user insights by deserializing object properties
 *
 * @internal
 * @param userInsights
 */
export default function deserializeUserInsights(userInsights: any): UserInsights {
    userInsights.engagement.last_visit_date = dateTime(userInsights.engagement.last_visit_date)

    return userInsights;
}